import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-right-pagination-arrow';
export var ID = 'icon-right-pagination-arrow';
/* eslint-disable max-len */

export var SVGRightPaginationArrow = function SVGRightPaginationArrow() {
  return React.createElement("symbol", {
    id: ID,
    width: "8px",
    height: "13px",
    viewBox: "0 0 8 13"
  }, React.createElement("path", {
    d: "M1.325 12.368L7.16 6.532c.09-.067.135-.18.135-.27 0-.112-.045-.224-.135-.29L1.325.134C1.235.045 1.145 0 1.033 0 .943 0 .83.045.74.135L.136.763C.045.83 0 .943 0 1.033c0 .112.045.224.135.29l4.916 4.94-4.915 4.915c-.09.09-.135.18-.135.292 0 .112.045.202.135.292l.606.606c.09.09.203.134.293.134.112 0 .202-.044.292-.134",
    fillRule: "evenodd"
  }));
};
/* eslint-disable max-len */

var RightPaginationArrow = function RightPaginationArrow(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGRightPaginationArrow
  });
};

RightPaginationArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default RightPaginationArrow;